import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import classes from './index.module.scss'
import { selectFilterByKey } from './store/slice'

export const Header = () => {
  const totalRecords = useSelector(selectFilterByKey('totalRecords'))

  return (
    <div className={classes.header}>
      <Translate
        value="userManagement.orderManagement.ORDER_TOTAL"
        quantity={totalRecords}
      />
    </div>
  )
}
